import React, { useState, useEffect, useRef } from "react";
import logo from "../../images/logo.png";
import medicalbag from "../../images/popuplogin.png";
import otpbag from "../../images/otpbag.png";
import { toast } from "react-hot-toast";
import { useCart } from "../../Context/Createcontext";
import { api_url } from "../../config/config";

const Popup = ({ onClose }) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [showOTPPopup, setShowOTPPopup] = useState(false);
  const [error, setError] = useState("");
  const [otpError, setOTPError] = useState("");
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = useState(60);
  const resendInterval = useRef(null);
  const [loading, setLoading] = useState(false);
  const [user_id, setUser_id] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const { fetchCartCount } = useCart();

  /* ── countdown timer ── */
  useEffect(() => {
    if (showOTPPopup) {
      setResendTimer(60);
      if (resendInterval.current) clearInterval(resendInterval.current);
      resendInterval.current = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(resendInterval.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => {
      if (resendInterval.current) clearInterval(resendInterval.current);
    };
  }, [showOTPPopup]);

  /* ── mobile input ── */
  const handleMobileChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    setMobileNumber(val);
    if (val.length === 10) setError("");
    else if (val.length === 0) setError("Mobile number is required.");
    else setError("Please enter a valid 10-digit mobile number.");
  };

  /* ── send OTP ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (mobileNumber.length === 0) {
      setError("Mobile number is required.");
      setLoading(false);
      return;
    }
    if (mobileNumber.length !== 10) {
      setError("Please enter a valid 10-digit mobile number.");
      setLoading(false);
      return;
    }
    try {
      const response = await fetch(`${api_url}/send-login-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile_number: mobileNumber }),
      });
      const data = await response.json();
      setLoading(false);
      if (response.ok) {
        setShowOTPPopup(true);
        setUser_id(data.user_id);
        setOtpToken(data.otpToken);
      } else {
        toast.error(data.message || "Failed to send OTP. Please try again.");
      }
    } catch {
      setLoading(false);
      toast.error("An error occurred. Please try again.");
    }
  };

  /* ── OTP input ── */
  const handleOTPChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    setOtp(val);
    if (val.length === 6) setOTPError("");
    else if (val.length === 0) setOTPError("OTP is required.");
    else setOTPError("Please enter a valid 6-digit OTP.");
  };

  /* ── verify OTP ── */
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (otp.length === 0) {
      setOTPError("OTP is required.");
      setLoading(false);
      return;
    }
    if (otp.length !== 6) {
      setOTPError("Please enter a valid 6-digit OTP.");
      setLoading(false);
      return;
    }
    try {
      const response = await fetch(`${api_url}/verify-login-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id, otpToken, otp }),
      });
      const data = await response.json();
      setLoading(false);
      if (response.ok) {
        localStorage.setItem("authToken", data.token);
        toast.success(data.message);
        if (fetchCartCount) fetchCartCount();
        window.dispatchEvent(new Event("authChanged"));
        onClose();
      } else {
        toast.error(data.message || "Failed to verify OTP. Please try again.");
      }
    } catch {
      setLoading(false);
      toast.error("An error occurred. Please try again.");
    }
  };

  /* ── resend OTP ── */
  const handleResendOTP = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${api_url}/send-login-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile_number: mobileNumber }),
      });
      const data = await response.json();
      setLoading(false);
      if (response.ok) {
        setUser_id(data.user_id);
        setOtpToken(data.otpToken);
        setResendTimer(60);
        toast.success("OTP resent successfully!");
        if (resendInterval.current) clearInterval(resendInterval.current);
        resendInterval.current = setInterval(() => {
          setResendTimer((prev) => {
            if (prev <= 1) {
              clearInterval(resendInterval.current);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        toast.error(data.message || "Failed to resend OTP. Please try again.");
      }
    } catch {
      setLoading(false);
      toast.error("An error occurred. Please try again.");
    }
  };

  /* ── Spinner ── */
  const Spinner = () => (
    <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="white"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="white"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );

  /* ────────────────────────────────────────────────────
     LEFT PANEL
  ──────────────────────────────────────────────────── */
  const LeftPanel = () => (
    <div className="hidden md:flex flex-col justify-between w-[45%] bg-[#162c2a] rounded-l-2xl p-7 relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute -top-10 -left-10 w-40 h-40 rounded-full bg-white/[0.04] pointer-events-none" />
      <div className="absolute bottom-10 -right-10 w-52 h-52 rounded-full bg-[#ff601e]/[0.08] pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full bg-[#5fbdb3]/[0.05] pointer-events-none" />

      {/* Logo */}
      <div className="relative z-10">
        <img src={logo} alt="MediSYS" className="h-9 w-auto object-contain" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col gap-5 my-6">
        <div>
          <h2 className="font-poppins font-bold text-[22px] text-white leading-tight">
            Your Health,
            <br />
            <span className="text-[#5fbdb3]">Our Priority.</span>
          </h2>
          <p className="font-poppins text-[12px] text-white/55 mt-2 leading-relaxed">
            Login to access your prescriptions, track orders, and get medicines
            delivered to your door.
          </p>
        </div>

        {[
          { icon: "🚚", text: "Free home delivery" },
          { icon: "💊", text: "Genuine medicines, verified pharmacists" },
          { icon: "📋", text: "Upload & manage prescriptions easily" },
          { icon: "⚡", text: "Quick login — no password needed" },
        ].map((f, i) => (
          <div key={i} className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-xl bg-white/[0.08] border border-white/[0.1] flex items-center justify-center text-[14px] flex-shrink-0">
              {f.icon}
            </div>
            <span className="font-poppins text-[12px] text-white/70 leading-snug">
              {f.text}
            </span>
          </div>
        ))}
      </div>

      {/* Trust badge */}
      <div className="relative z-10 flex items-center gap-2 bg-white/[0.06] border border-white/[0.1] rounded-xl px-3 py-2.5">
        <div className="w-7 h-7 rounded-lg bg-[#ff601e] flex items-center justify-center flex-shrink-0">
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        </div>
        <div>
          <p className="font-poppins font-semibold text-[11px] text-white">
            Licensed Pharmacy
          </p>
          <p className="font-poppins text-[10px] text-white/45">
            GSTIN: 36ABTFM9976H1Z7
          </p>
        </div>
      </div>
    </div>
  );

  /* ────────────────────────────────────────────────────
     MODAL
     Popup panel:   z-[10000]
     Backdrop:      z-[9998]   ← BELOW the Toaster (z: 999999 in App)
     Toaster:       z: 999999  ← always on top via containerStyle in App.jsx
  ──────────────────────────────────────────────────── */
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9998] px-4">
      {/*
        Backdrop z-[9998] — sits below the popup panel (z-[10000])
        AND below the Toaster portal (z: 999999 set in App.jsx).
        This means toasts always float above BOTH the backdrop and the modal.
      */}
      <div
        className="fixed inset-0 bg-[#0a1715]/75 backdrop-blur-sm z-[9998]"
        onClick={onClose}
      />

      {/* Modal panel — z-[10000] so it sits above the backdrop */}
      <div
        className="relative flex w-full max-w-[680px] bg-white rounded-2xl shadow-2xl overflow-hidden z-[10000]"
        onClick={(e) => e.stopPropagation()}
      >
        <LeftPanel />

        {/* ── RIGHT PANEL ── */}
        <div className="flex-1 flex flex-col">
          {/* Header bar */}
          <div className="flex items-center justify-between px-6 py-4 bg-[#f8fafa] border-b border-[#e2eaea]">
            <img
              src={logo}
              alt="MediSYS"
              className="h-7 w-auto object-contain md:hidden"
            />
            <p className="hidden md:block font-poppins font-semibold text-[14px] text-[#1e4a46]">
              {showOTPPopup ? "Verify OTP" : "Login / Register"}
            </p>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-xl bg-[#e2eaea] hover:bg-[#ff601e] flex items-center justify-center transition-all duration-200 group ml-auto"
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  className="text-[#374747] group-hover:text-white"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="flex flex-col items-center justify-center px-7 py-6 flex-1">
            {showOTPPopup ? (
              /* ── OTP VIEW ── */
              <>
                <img
                  src={otpbag}
                  alt="OTP"
                  className="w-[90px] h-[90px] object-contain mb-4"
                />

                <h3 className="font-poppins font-bold text-[16px] text-[#162c2a] mb-1">
                  Enter Verification Code
                </h3>
                <p className="font-poppins text-[12px] text-[#607d7b] mb-5 text-center">
                  We've sent a 6-digit OTP to{" "}
                  <span className="font-semibold text-[#1e4a46]">
                    +91 {mobileNumber}
                  </span>
                </p>

                <form
                  onSubmit={handleOtpSubmit}
                  className="w-full flex flex-col gap-3"
                >
                  <div className="flex flex-col gap-1">
                    <input
                      type="text"
                      placeholder="• • • • • •"
                      value={otp}
                      onChange={handleOTPChange}
                      maxLength="6"
                      className="w-full h-12 border-[1.5px] border-[#e2eaea] rounded-xl font-poppins text-[18px] font-bold text-center text-[#1e4a46] tracking-[0.5em] outline-none focus:border-[#1e4a46] focus:shadow-[0_0_0_3px_rgba(95,189,179,0.15)] transition-all duration-200 placeholder-[#c5d5d4]"
                    />
                    {otpError && (
                      <p className="text-red-500 text-[11px] font-poppins text-center">
                        {otpError}
                      </p>
                    )}
                  </div>

                  {/* Resend timer */}
                  <div className="flex justify-center">
                    {resendTimer > 0 ? (
                      <p className="font-poppins text-[12px] text-[#8faba9]">
                        Resend OTP in{" "}
                        <span className="font-semibold text-[#1e4a46]">
                          0:{resendTimer.toString().padStart(2, "0")}s
                        </span>
                      </p>
                    ) : (
                      <button
                        type="button"
                        disabled={loading}
                        onClick={handleResendOTP}
                        className="font-poppins text-[12px] font-semibold text-[#ff601e] hover:text-[#e55519] disabled:text-[#8faba9] transition-colors"
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>

                  {/* Verify */}
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full h-11 bg-[#ff601e] hover:bg-[#e55519] disabled:bg-[#8faba9] text-white font-poppins font-semibold text-[14px] rounded-xl transition-all duration-200 shadow-[0_3px_12px_rgba(255,96,30,0.3)] hover:shadow-[0_5px_18px_rgba(255,96,30,0.4)] hover:-translate-y-px"
                  >
                    {loading ? (
                      <span className="flex items-center justify-center gap-2">
                        <Spinner />
                        Verifying…
                      </span>
                    ) : (
                      "Verify & Login"
                    )}
                  </button>

                  {/* Back */}
                  <button
                    type="button"
                    onClick={() => {
                      setShowOTPPopup(false);
                      setOtp("");
                      setOTPError("");
                    }}
                    className="font-poppins text-[12px] text-[#8faba9] hover:text-[#374747] transition-colors text-center"
                  >
                    ← Change mobile number
                  </button>
                </form>
              </>
            ) : (
              /* ── LOGIN VIEW ── */
              <>
                <img
                  src={medicalbag}
                  alt="Login"
                  className="w-[90px] h-[90px] object-contain mb-4"
                />

                <h3 className="font-poppins font-bold text-[16px] text-[#162c2a] mb-1">
                  Quick Login / Register
                </h3>
                <p className="font-poppins text-[12px] text-[#607d7b] mb-5 text-center">
                  Enter your mobile number to receive a one-time password
                </p>

                <form
                  onSubmit={handleSubmit}
                  className="w-full flex flex-col gap-3"
                >
                  <div className="flex flex-col gap-1">
                    <label className="font-poppins font-medium text-[12px] text-[#374747]">
                      Mobile Number <span className="text-[#ff601e]">*</span>
                    </label>
                    <div className="flex items-center border-[1.5px] border-[#e2eaea] rounded-xl overflow-hidden focus-within:border-[#1e4a46] focus-within:shadow-[0_0_0_3px_rgba(95,189,179,0.15)] transition-all duration-200">
                      <div className="flex items-center gap-1.5 px-3 bg-[#f8fafa] border-r border-[#e2eaea] h-11 flex-shrink-0">
                        <span className="text-[14px]">🇮🇳</span>
                        <span className="font-poppins font-semibold text-[13px] text-[#374747]">
                          +91
                        </span>
                      </div>
                      <input
                        type="tel"
                        placeholder="10-digit mobile number"
                        value={mobileNumber}
                        onChange={handleMobileChange}
                        maxLength="10"
                        className="flex-1 h-11 px-3 bg-transparent outline-none font-poppins text-[13px] text-[#1a2625] placeholder-[#8faba9]"
                      />
                    </div>
                    {error && (
                      <p className="text-red-500 text-[11px] font-poppins">
                        {error}
                      </p>
                    )}
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full h-11 bg-[#162c2a] hover:bg-[#1e4a46] disabled:bg-[#8faba9] text-white font-poppins font-semibold text-[14px] rounded-xl transition-all duration-200 shadow-[0_2px_10px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_16px_rgba(22,44,42,0.35)] hover:-translate-y-px"
                  >
                    {loading ? (
                      <span className="flex items-center justify-center gap-2">
                        <Spinner />
                        Sending OTP…
                      </span>
                    ) : (
                      <span className="flex items-center justify-center gap-2">
                        Get OTP
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </span>
                    )}
                  </button>

                  {/* T&C */}
                  <p className="font-poppins text-[10px] text-[#8faba9] text-center leading-relaxed">
                    By continuing, you agree to our{" "}
                    <span className="text-[#1e4a46] font-medium cursor-pointer hover:underline">
                      Terms & Conditions
                    </span>{" "}
                    and{" "}
                    <span className="text-[#1e4a46] font-medium cursor-pointer hover:underline">
                      Privacy Policy
                    </span>
                  </p>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
